export const iconFontAwesomeNumbers9 = (
	<i className="fa-solid fa-9"></i>
);
